import React, { useRef } from "react";
import { IonSlides, IonSlide, IonImg, IonLabel } from "@ionic/react";
import { connect } from "react-redux";
import {
	getRecommendedServices,
	saveCatelogVehicleId,
	setSelectedVehicle,
} from "../../Store/Actions";
import { COLLECTIONS } from "../../firebase";
import "../../global.scss";
import { CLIENT_NAME, DEFAULT } from "../../constants";

interface SlideProps {
	carslideArray: Array<any>;
}

const CarsSlides: React.FC = (props: any) => {
	const [state, setState] = React.useState(0);
	const mySlides = useRef(null as any);
	const [manualSlide, setManualSlide] = React.useState(true);
	const [currentSlide, setCurrentSlide] = React.useState(-1);

	React.useEffect(() => {
		changeSlide();
	}, [props.selectedVehicleRef]);

	const changeSlide = async () => {
		// console.log("CHANGE V S 1 =====", props);

		const swiper = await mySlides?.current?.getSwiper();

		if (!!props.sliderCatelogVehicleId) {
			if (props.userVehiclesList.length) {
				// props.userVehiclesList.map(
				//   (ele: any) =>
				//     (ele.imageUrl =
				//       "https://firebasestorage.googleapis.com/v0/b/ax-b2c-test.appspot.com/o/oWeIuv08J9SwEEwVIKI9uhBiBgn1%2Fprofile%2F219986.png?alt=media&token=6bdc559e-3b97-4275-95b8-c279bdf94609"),
				// );

				// const a = props.userVehiclesList.findIndex(
				//   (ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId,
				// );
				// console.log(".selectedVehicleRef v ===== ", props);
				// console.log("props.selectedVehicleRef v ===== ", props.selectedVehicleRef.split("/").pop());
				const a = props.userVehiclesList.findIndex(
					(ele: any) => ele.did === (props.selectedVehicleRef || "").split("/").pop()
				);

				// console.log("Selected v ===== ", a);

				await setState(a);

				if (currentSlide !== a) {
					setCurrentSlide(a);
					swiper.slideTo(a);
				}
			}
		}
	};

	const getIndex = async (event: any) => {
		// console.log("Get Index 60 =====", props);
		changeSlide();
		await event.target.getActiveIndex().then(async (value: any) => {
			// console.log("Get Index 65 =====", value);
			// setCurrentSlide(value);
			const addressDetails = (props.userAddressList || []).find(
				(ele: any) => ele.did === props.selectedAddressRef
			);

			if (!!addressDetails) {
				if (
					!!props.userVehiclesList.length &&
					!!props.userVehiclesList[value].catalogVehicleId
				) {
					let workshopId: any = "";

					if (!!props.location) {
						if (!!props.location.state) {
							if (!!props.location.state.workshopId) {
								workshopId = props.location.state.workshopId;
							}
						}
					}

					if (workshopId === "") {
						if (localStorage.getItem("workshopId")) {
							workshopId = localStorage.getItem("workshopId");
						}
					}

					await props.getRecommendedServices({
						catalogVehicleId: props.userVehiclesList[value].catalogVehicleId,
						latitude: addressDetails.latitude,
						longitude: addressDetails.longitude,
						workshopId: workshopId,
						clientName: CLIENT_NAME,
						make: props.userVehiclesList[value].make,
					});
					await props.saveCatelogVehicleId(
						props.userVehiclesList[value].catalogVehicleId
					);
					await props.setSelectedVehicle(
						`${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${props.userVehiclesList[value].did}`
					);
				}
			}
		});
	};

	const getInitialSlide = (slideId: any) => {
		if (!!slideId) {
			if (props.userVehiclesList.length) {
				const a = props.userVehiclesList.findIndex(
					(ele: any) => ele.catalogVehicleId === slideId
				);
				return a;
			}
		}
		return 0;
	};

	const slideTo = async (event?: any) => {
		if (props.userVehiclesList.length) {
			const a = props.userVehiclesList.findIndex(
				(ele: any) => ele.did === (props.selectedVehicleRef || "").split("/").pop()
			);

			await event.target.slideTo(a);
		}
	};
	const carResponsive = [
		{
			image: "/images/carSlide1.svg",
			model: "Add New Vehicle",
			data: "Choose from 3000+ models",
			service: "Next Schedule",
		},
	];
	return (
		<>
			{Boolean(props.userVehiclesList.length) ? (
				<IonSlides
					ref={mySlides}
					pager={(props.userVehiclesList || []).length > 1 ? true : false}
					options={{
						initialSlide: state < 0 ? 0 : state,
						loop: false,
						autoplay: false,
						// pagination: {
						//   el: ".swiper-pagination",
						//   type: "bullets",
						//   clickable: true,
						//   bulletElement: "span",
						//   bulletClass: "swiper-pagination-bullet",
						//   bulletActiveClass: "swiper-pagination-bullet-active",
						//   renderBullet: function (index: any, className: any) {
						//     return '<span class="swiper-pagination-bullet">' + "</span>";
						//   },
						// },
						// pagination: {
						//   el: ".swiper-pagination",
						//   type: "bullets",
						//   clickable: true,
						// },
					}}
					// onIonSlideTouchStart={(event: any) => {
					//   setManualSlide(false);
					// }}
					onIonSlidesDidLoad={(event: any) => {
						event.target.slideTo(state);
						getIndex(event);
					}}
					onIonSlideWillChange={(event: any) => {
						getIndex(event);
					}}
					className="slides-pagination-styles"
					key={props.userVehiclesList.map((slide: any) => slide.did).join("_")}
				>
					{props.userVehiclesList.map((ele: any, ind: any) => (
						<IonSlide key={ind}>
							<div
								className="car_slides"
								style={{
									marginBottom: props.userVehiclesList.length === 1 ? "45px" : "20px",
								}}
							>
								<IonImg src={ele.imageUrl} className="carSliderImages" />
								{/* <IonLabel className="model" color="secondary">
                  {ele.model}
                </IonLabel> */}
								<div className="dashboard_dropdown">
									<IonLabel className="model" color="secondary">
										{ele.make} {ele.model}
									</IonLabel>
									<IonImg
										onClick={() =>
											props.history.push(`/portal/manage-your-vehicle/${ele.did}`)
										}
										className="arrow_dropdown"
										src="/images/dropdown_icon.svg"
									/>
								</div>
								<IonLabel className="year">
									{ele.year} {!!ele.year && ","} {ele.fuelType}
								</IonLabel>
								<div>
									<IonLabel className="empty_data" color="light">
										{"Next Schedule"}
									</IonLabel>
								</div>
								<IonLabel className="dashes" color="light">
									{"-------"}
								</IonLabel>
							</div>
						</IonSlide>
					))}
				</IonSlides>
			) : (
				<IonSlides
					onClick={() => props.history.push("/portal/add-vehicles")}
					pager={false}
					options={{
						loop: false,
						autoplay: false,
						scrollbar: false,
					}}
					className="cursor_pointer_style empty_div"
				>
					{carResponsive.map((ele: any, ind: any) => (
						<IonSlide key={ind}>
							<div className="empty_parent">
								<div>
									<IonImg src={ele.image} className="manage_vehicle_img" />
								</div>
								<div className="empty_model">
									<IonLabel className="brand_text" color="dark">
										{ele.model}
									</IonLabel>
								</div>
								<div>
									<IonLabel className="empty_data" color="dark">
										{ele.data}
									</IonLabel>
								</div>
								<div>
									<IonLabel className="empty_data" color="light">
										{ele.service}
									</IonLabel>
								</div>
								<IonLabel className="dashes" color="light">
									{"-------"}
								</IonLabel>
							</div>
						</IonSlide>
					))}
				</IonSlides>
			)}
		</>
	);
};

export default connect(
	({ userInfo: { userVehiclesList, sliderCatelogVehicleId } }: any) => ({
		userVehiclesList,
		sliderCatelogVehicleId,
	}),
	{ getRecommendedServices, saveCatelogVehicleId, setSelectedVehicle }
)(CarsSlides);
